define('runtime',['underscore', "utils/dom_ready", "utils/hide_plugin", 'event'], function(_, domReady, HidePlugin, Event){
  return {
    __options: {},
    setOptions: function(opts){
      HidePlugin._setHidePluginCallback(opts.hidePluginCallback);
      this.__options.appId = opts.appId;
      this.__options.remoteHelper = opts.channelUrl;
      this.__options.meta = opts.meta;
      this.__options.responseType = opts.responseType || 'token';
      this.__options.globalRedirectUri = opts.redirectUri;
      if (opts.authResponse) {
        this.setAuthResponse(opts.authResponse);
      }
    },

    init: function(options){
      if (this.initialized()) {
        return;
      }
      if (!this.checkOptions()){
        this.setOptions(options);
      }
      if (this.checkOptions()){
        this.__options.initialized = true;
        Event.fire('id.init');
      }
    },

    reset: function() {
      this.__options = {};
    },

    getAppId: function(){
      return this.__options.appId;
    },

    initialized: function(){
      return !!this.__options.initialized;
    },

    checkOptions: function(){
      return !!this.__options.appId;
    },

    setStatus: function(status){
      this.__options.status = status;
    },

    getLoginStatus: function(){
      return {status: this.__options.status, authResponse: this.__options.authResponse };
    },

    setAuthResponse: function(resp){
      this.__options.authResponse = resp;
    },

    getOAuthToken: function(){
      var response = this.getAuthResponse();
      if (response && response.access_token)
      {
        return response.access_token;
      }
      return null;
    },

    getAuthResponse: function(){
      return this.__options.authResponse;
    },

    getRedirectUri: function(other){
      return _.isString(other) ? other : this.__options.globalRedirectUri || document.location.href;
    },

    getDefaultMeta: function(){
      return this.__options.meta || {};
    },

    getDefaultResponseType: function(){
      return this.__options.responseType;
    }
  };
});

